






























































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { onlyNumber } from '@/utils/common'
import { filtroSemAcento as filtrarSemAcento } from '@/utils/textoBusca'
import _ from 'lodash'

@Component

export default class ComponentRemuneracaoValidacaoRightNavBar extends Vue {
  fltLoading: boolean = false
  searchProfissional: any = ''
  loadingProfissionalFilter: boolean = false
  isSelecting: boolean = false
  profissionalName: string = ''

  profissionaisDebounced = _.debounce(param => this.getStore.getProfissionaisExecutantesByGeracao(param), 500)
  menuDe: boolean = false
  menuAte: boolean = false

  $refs!: {
    menuDe: any,
    menuAte: any,
  }

  get statusGeracaoRepasse() {
    return this.getStore.selectedStatus
  }

  set statusGeracaoRepasse(value: any) {
    this.getStore.setSelectedStatus(value.key)
  }

  get status() {
    return this.getStore.statusList
  }

  get selectedPrestador() {
    return this.getStore.selectedPrestador
  }

  set selectedPrestador(value) {
    this.getStore.setSelectedPrestador(value)
  }

  get getPrestadoresList() {
    return this.getStore.gerarRepassePrestadores
  }

  get filterLoading() {
    return this.fltLoading
  }

  set filterLoading(value: boolean) {
    this.fltLoading = value
  }

  get getStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get drawer() {
    return this.getStore.filterValidacaoEGeracaoRepasseDrawer
  }

  set drawer(value: boolean) {
    this.getStore.setFilterValidacaoEGeracaoRepasseDrawer(value)
  }

  get getProfissionaisExecutanteList() {
    return this.getStore.profissionaisExecutantes
  }

  get selectedProfissionalExecutante(){
    return this.getStore.selectedProfissionalExecutante
  }

  set selectedProfissionalExecutante(value: any){
    if(value) this.getStore.setSelectedProfissionalExecutante(value.userId)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  // A lista de prestadores da geração é local, então o filtro por nome acontece aqui — precisa
  // ignorar acento igual o banco faz nas buscas remotas.
  filtroSemAcento(item: any, queryText: string, itemText: string): boolean {
    return filtrarSemAcento(item, queryText, itemText)
  }

  async search() {
    this.filterLoading = true
    this.getStore.setPaginaValidacaoEGeracao(1)
    const id = this.getStore.idForLoadValidacaoEGeracaoRepasse
    await this.getStore.getGeracaoDeRepassesItemsVisualizar(id)
    this.getStore.setFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }

  hasAnyFilter(): boolean {
    return this.getStore.selectedStatus.length > 0 || this.getStore.selectedPrestador !== '' || this.getStore.selectedProfissionalExecutante !== ''
  }

  async clear() {
    this.getStore.clearFilterValidacaoEGeracaoRepasse()
    this.getStore.setFilterOn(false)
    this.getStore.setProfissionaisExecutantes([])
    await this.search()
  }

  async selectStatus(item: any) {
    this.statusGeracaoRepasse = item
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight
    }
  }

  changeProfissionalExecutante(value) {
    if(value){
      this.profissionalName = value.nome
    } else {
      this.profissionalName = ''
    }
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      if (!this.getStore.modal.modalAlterarPrestador) {
        this.getStore.setProfissionaisExecutantes([])
      }
      return
    }

    if(this.profissionalName === val){
      return
    } else {
      this.selectedProfissionalExecutante = null
    }

    this.loadingProfissionalFilter = true
    if(this.profissionaisDebounced) await this.profissionaisDebounced(val)
  }

  @Watch('getProfissionaisExecutanteList')
  async onGetProfissionaisExecutanteListChanged() {
    this.loadingProfissionalFilter = false
  }

  async init() {
    this.getStore.getConveniosRepasse()
  }

  async mounted() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
    await this.init()
  }

  async updated() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }
}
